import React, { memo } from 'react';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import type { IconButtonSpacing } from '@atlaskit/button/new';
import type { Placement } from '@atlaskit/popper';
import type { Board } from '@atlassian/jira-boards-common/src/model/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { ThemedIconButton } from '@atlassian/jira-project-theme-components/src/ui/themed-button-new/ThemedButtonNew.tsx';
import { PopupTrigger } from '@atlassian/entry-point-popup';
import messages from './messages.tsx';
import { subspaceActionsPopupEntryPoint } from './subspace-action-popup/entrypoint.tsx';

export type BoardWithDataId = Board & { dataId: string };

export type SubspaceActionsProps = {
	iconButtonSpacing?: IconButtonSpacing;
	placement?: Placement;
};

export const SubspaceActions = memo(
	({
		iconButtonSpacing = 'default',
		placement = 'bottom-start',
	}: SubspaceActionsProps): React.JSX.Element | null => {
		const { formatMessage } = useIntl();

		return (
			<PopupTrigger
				entryPoint={subspaceActionsPopupEntryPoint}
				trigger={(triggerProps) => (
					<ThemedIconButton
						{...triggerProps}
						icon={(iconProps) => <ShowMoreHorizontalIcon {...iconProps} size="small" />}
						label={formatMessage(messages.showMoreIconLabel)}
						appearance="subtle"
						spacing={iconButtonSpacing}
						testId="navigation-apps-sidebar-nav4-sidebars-content-projects-subspaces.actions"
					/>
				)}
				placement={placement}
				shouldRenderToParent
			/>
		);
	},
);
